import { css } from 'styled-components';

export const borderRadius = () =>
  css`
    border-radius: 5px;
  `;



// WEBPACK FOOTER //
// ./src/styles/utils/borderRadius.js